// Enums
import { KycMethodsEnumeration } from 'containers/kyc/enumerations/kyc-methods.enumeration';
// Types
import { KycLandingApiType } from '../../types/kyc-landing-api.type';

const getVideocallConsents = ({
  consents,
  method,
}: KycLandingApiType): Pick<KycLandingApiType, 'consents'> | Record<never, never> =>
  method === KycMethodsEnumeration.VIDEOCALL ? { consents } : {};

export { getVideocallConsents };
